export default {
  setting: '设置',
  account: '账号设置',
  password: '密码设置',
};
